import apiClient from '../client';

export interface ForecastPart {
  PartNumber: string;
  UnitsSold: number;
  OrderCount: number;
  Revenue: number;
  DailyVelocity: number;
  TopChannel: string;
  TopChannelUnits: number;
  TopChannelRevenue: number;
}

export interface ForecastChannel {
  Channel: string;
  UnitsSold: number;
  OrderCount: number;
  Revenue: number;
  UniquePartNumbers: number;
  AvgRevenuePerUnit: number;
  DropShipPct: number;
}

export interface ForecastData {
  parts: ForecastPart[];
  channels: ForecastChannel[];
  rangeDays: number;
  totalUnits: number;
  totalRevenue: number;
}

export const forecastService = {
  getManufacturingForecast: async (dateFrom: string, dateTo: string): Promise<ForecastData> => {
    const params = new URLSearchParams({ dateFrom, dateTo });
    const res = await apiClient.get<ForecastData>(`/forecast?${params}`);
    return res.data;
  },
};
